import { RecordColumnValueType, RecordType } from '../schema/shared';

/**
 * Create a header configuration.
 *
 * @return  {RecordColumnValueType | undefined}  Header configuration
 */
const getHeaderConfig = (
  record: RecordType,
  primary: string,
  secondary: string
) => {
  let config: RecordColumnValueType | undefined;

  // Check for the primary property.
  if (record.hasOwnProperty(primary)) {
    config = { primary };

    // Check for the secondary property. Only create the object property if the
    // record has the secondary field property.
    if (record.hasOwnProperty(secondary)) {
      config.secondary = secondary;
    }
  }

  return config;
};

/**
 * Dynamically determine which properties to show based on the available Record
 * data. This is used to gracefully account for new record types.
 *
 * @param   {RecordType} record  Record data
 *
 * @return  {RecordColumnValueType[]} Record headers
 */
export const parseColumns = (record: RecordType) => {
  const headers: RecordColumnValueType[] = [];

  // Determine if the source IP address exists, which is a common property for
  // network-based properties.
  const srcIpConfig = getHeaderConfig(record, 'srcDevice_ip', 'srcPort');
  if (srcIpConfig) {
    headers.push(srcIpConfig);

    // Also check for destination IP address properties.
    const dstIpConfig = getHeaderConfig(record, 'dstDevice_ip', 'dstPort');
    if (dstIpConfig) {
      headers.push(dstIpConfig);
    }
  }
  // Otherwise, include vendor and product properties if they exist.
  else {
    const sysConfig = getHeaderConfig(
      record,
      'metadata_vendor',
      'metadata_product'
    );

    if (sysConfig) {
      headers.push(sysConfig);
    }
  }

  // Enforce an empty final column. This will be replaced by applicable favorite
  // fields when appropriate.
  return [...headers, {}];
};
